module.exports = "//static.hsappstatic.net/marketplace-ui-details/static-1.1656/img/agent-overview-fallback.png"